module.exports = __webpack_public_path__ + "static/media/News&Updates2x.8c861c41.png";